import { proximaApi } from '../proximaApi'
import { type LedgerAccountDetails } from '../schema-dtos/AssetHolderFinancePayloadDtos'

const SUB_URL = '/ledgers/accounts'

export const financeApi = proximaApi.injectEndpoints({
  endpoints: (builder) => ({

    getWallets: builder.query<LedgerAccountDetails[], Partial<number>>({
      query: (assetHolderId: number) => ({
        url: `${SUB_URL}/${assetHolderId}/wallets/transaction-summaries`,
        method: 'GET'
      }),
      providesTags: ['AssetHolderFinancials']
    })
  })
})

export const useGetWalletsQuery = financeApi.endpoints.getWallets.useQuery
